import styled, { gapSize } from 'theme';

export const ButtonContainer = styled.div`
  display: flex;
  gap: ${gapSize(2)};
`;
